// report 模組 W2：查詢統計頁群 10 頁的整頁 body（批次 14，Gitea issue #22）。
// 掛在 PageBehavior.reportBody（ReportPage hooks 前早退）。
//
// 行號基準＝ePortfolio_work/ePortfolio-tsgh（逐檔 grep -n 親驗 2026-09-24）。
//
// 各頁形狀（查詢表單＋查詢鈕＋結果表＋列印；Chart.js 圖表**不引**＝§3.2 不加套件，
// 表格已呈現同資料，圖表缺口記進度檔/KNOWN-NOT-DONE）：
//   1. LoginStatic（登入使用狀況統計，tsgh/LoginStatic.jsp）：logDateStart/logDateEnd
//      （:201/:215 datepicker required＋橡皮擦 :226-230）＋查詢 :231。
//      doQuery（:51-121）：errMessage 組字『請選擇'+errMessage（:66-74；**兩個條件都檢
//      logDateEnd**（:65 兩支都是 #logDateEnd——logDateStart 從未被檢＝copy-paste
//      legacy-known-issue 照實）→ getLoginLogStaticAjax → 表（項目/登入次數/登入人次，
//      thead :250；rows yearMonth/loginTime/loginAccountNums :114-119）＋pie 圖×2（不畫）。
//   2. classFormStatic（課程滿意度調查統計＋變體 toClassForm7＝基本課程滿意度調查統計，
//      tsgh/classFormStatic.jsp）：refType hidden（:303，契約值 6/7）／教師 teacherId（:341）／
//      課程 classId（:349）／表單時間 submitDateS/E（:362/:368 required）／查詢 :380／列印 :381。
//      doQuery（:67-162）：classId 空且起訖空 → 請選擇表單時間（:81-98；**學年度/醫院檢核
//      整段被註解** :74-89＝legacy-known-issue 照實）→ getClassFormStaticAjax → 表：
//      **thead 月份/登入次數/登入人次（:398，3 欄）vs 資料列 6 欄（fieldTitlem/averageValue/
//      minValue/maxValue/medianValue/majorityValue :142-145）——表頭與資料欄數不符＝
//      copy-paste legacy-known-issue 照實渲染**＋線/柱圖（不畫）。printForm（:274-289）＝
//      window.print 流程（雛形提示呈現，不帶 data-effect）。
//   3. planFormStatic（主治醫師教學滿意度統計＋變體 toPlanForm5＝住院醫師教學滿意度統計，
//      tsgh/planFormStatic.jsp）：refType hidden（:291，4/5）／教師 teacherId（:329）／
//      表單時間 submitDateS/E required（:342/:348）／查詢 :360／列印 :361。doQuery（:53）：
//      請選擇表單時間（:79-83——**學年度/醫院檢核同被註解**）→ 同 2 的六欄統計表（thead
//      項目/平均/最低/最高/中位數/眾數 :378，**欄數相符**）。
//   4. planFormStatic2（教學門診稽核表統計＋變體 toPlanForm9＝教學住診暨床邊教學統計、
//      toPlanForm10＝晨會訓練官稽核檢查表統計，tsgh/planFormStatic2.jsp）：refType hidden
//      （:296，8/9/10）／教師 teacherId（:334）／訓練階段科部 phaseDepartmentId required
//      （:345，**第一個 option 全部** :346）／表單時間 submitDateS/E required（:361/:367）／
//      查詢 :379／列印 :380。doQuery（:59-190）：請選擇表單時間（:80-88）→
//      getPlanFormStaticAjax（submitDateS/E/phaseDepartmentId/refType :92-95）→
//      **list 空物件 → 無資料!（:106）** → 表（項目/通過率 thead :397；passRate ×100
//      toFixed(2) :122/:147-149，**無 % 後綴**）＋bar/pie 圖（不畫）。
//   5. coreSkillReportByForm／ByStudent（核心技能統計(依技能)/(依學員)，tsgh/coreSkillReport*.jsp）：
//      queryType hidden（value 1/0，契約值；by-form :100）／學年度 annualId／醫院 organizationId／
//      訓練類別 jobTypeId（by-form 表單 :162-201 內；by-student 同構）＋查詢 btnQuery。
//      **ready 即自動查詢**（$(document).ready → doQuery，by-form :8-11/by-student :10-13）。
//      doQuery 無驗證（valid 被註解 :28-31＝legacy-known-issue 照實）→ getCoreskillReportListAjax →
//      by-form 表：項目(formName)/完成率（realFillNum/needFillNum ×100 toFixed(2)，兩者>0 才計
//      否則 '0.00%'，:16-26）＋ order :32；by-student 表：學員姓名＋動態欄（欄名＝formName+
//      needFillNum :57/:87；**formName 以 '4-1基本及高階急救_' 開頭且 realFillNum==1 → 顯示 0.5**
//      :92-94 legacy 特例照實）＋表頭二列（學員姓名/應完成數…）。
//      契約欄位：queryType(hid)/annualId/organizationId/jobTypeId（右欄群未捕捉——照契約 4 欄）。
//
// 雛形資料策略：
//   - 結果表＝`dataSource.list(pageId, { filters })`＋resource-rules 結果種子（掛列上；
//     body 只渲染帶統計鍵的列——種子列有統計鍵、fixtures 通用列沒有）【雛形值待實機校準】。
//   - 查詢真打 list（D-1；data-effect list:<pageId>）；列印＝提示呈現（不帶 data-effect）。
//   - 圖表不引 Chart.js（§3.2）；表頭與資料欄數不符（classFormStatic）照實渲染並標註。
// 【證據等級】§7 第 3 級（原始碼）。

import { useEffect, useState, type ReactElement } from 'react';
import { BarCanvas, LineCanvas, PieCanvas, chartColorAt } from '@/components/base/ChartCanvas';
import { Button } from '@/components/base/Button';
import { Select } from '@/components/base/Select';
import { Table, type TableColumn, type TableRow } from '@/components/base/Table';
import { useDialogs } from '@/components/layouts';
import { useDataSource } from '@/mocks';
import { selectOptionsOverride } from '@/mocks/legacy-fields';
import { toUiKey } from '@/pages/templates/shared';
import type { Row } from '@/mocks/types';
import {
  ACCOUNT_JOB_TYPE_OPTIONS,
  ACCOUNT_ORGANIZATION_OPTIONS,
  COURSE_CLAZZ_ANNUAL_OPTIONS,
  COURSE_CLAZZ_TEACHER_OPTIONS,
  ACCOUNT_DEPARTMENT_OPTIONS,
  REPORT_CLASS_OPTIONS,
} from '@/mocks/resource-rules';
import { ReportPanel, ReportRow } from './ReportKit';

/** 查詢表單值 hook＋結果表資料（list filters 真打；只渲染帶統計鍵的列）。 */
function useStatQuery(pageId: string, statKey: string, onEmpty?: () => void) {
  const dataSource = useDataSource();
  const dialogs = useDialogs();
  const [rows, setRows] = useState<readonly Row[]>([]);
  const [busy, setBusy] = useState(false);
  const load = (filters: Record<string, string>) => {
    void (async () => {
      setBusy(true);
      try {
        const result = await dataSource.list(pageId, { page: 1, pageSize: 50, filters });
        const stat = result.rows.filter((row) => row[statKey] !== undefined);
        setRows(stat);
        // planFormStatic2 :106：查無資料 → alert『無資料!』（legacy 對空 list 的處理）。
        if (stat.length === 0 && onEmpty !== undefined) {
          onEmpty();
        }
      } catch (cause: unknown) {
        await dialogs.alert(cause instanceof Error ? cause.message : '查詢失敗');
      } finally {
        setBusy(false);
      }
    })();
  };
  return { rows, busy, load };
}

/** 查詢/列印鈕列。 */
function StatActions(props: {
  pageId: string;
  onQuery: () => void;
  busy: boolean;
  hasPrint: boolean;
}): ReactElement {
  const dialogs = useDialogs();
  return (
    <>
      <Button
        uiId={`${props.pageId}-query-btn`}
        variant="primary"
        size="sm"
        type="button"
        // C5-j：查詢真的呼叫 dataSource.list（filters）。
        dataEffect={`list:${props.pageId}`}
        disabled={props.busy}
        onClick={props.onQuery}
      >
        查詢
      </Button>
      {props.hasPrint ? (
        <Button
          uiId={`${props.pageId}-print-btn`}
          variant="default"
          size="sm"
          type="button"
          // printForm（classFormStatic.jsp:274-289 等）＝window.print 流程；雛形提示呈現（B1-3 模式）。
          onClick={() => {
            void dialogs.info('雛形不提供列印流程，此按鈕僅示範列印入口。');
          }}
        >
          列印
        </Button>
      ) : null}
    </>
  );
}

/** 日期起訖（type=date）＋橡皮擦。 */
function StatDateRange(props: {
  pageId: string;
  ctx: { v: Readonly<Record<string, string>>; set: (key: string, next: string) => void };
  startName: string;
  endName: string;
  required?: boolean;
  eraser: boolean;
}): ReactElement {
  const { pageId, ctx } = props;
  // 批次 50（工作項 4）：uiId 字尾一律 toUiKey kebab 化（§10.3 規則 1）；name 參數本身
  // 不動＝name 屬性/ctx.set(name) payload key 域零影響（startName/endName 是 payload key）。
  const control = (name: string) => (
    <input
      data-ui-id={`${pageId}-field-${toUiKey(name)}`}
      name={name}
      type="date"
      required={props.required}
      className="rounded border border-border px-2 py-1 text-sm"
      value={ctx.v[name] ?? ''}
      onChange={(event) => {
        ctx.set(name, event.target.value);
      }}
    />
  );
  return (
    <>
      <ReportRow pageId={pageId} name={props.startName} label="表單時間：">
        {control(props.startName)}
      </ReportRow>
      <ReportRow pageId={pageId} name={props.endName} label="~">
        {control(props.endName)}
        {props.eraser ? (
          <Button
            uiId={`${pageId}-field-eraser-${toUiKey(props.startName)}`}
            variant="default"
            size="sm"
            type="button"
            onClick={() => {
              ctx.set(props.startName, '');
              ctx.set(props.endName, '');
            }}
          >
            清除
          </Button>
        ) : null}
      </ReportRow>
    </>
  );
}

// ---------------------------------------------------------------------------
// 1. 登入使用狀況統計（report-tsgh-login-static）
// ---------------------------------------------------------------------------

export function LoginStaticBody({ pageId }: { pageId: string }): ReactElement {
  const dialogs = useDialogs();
  const [values, setValues] = useState<Record<string, string>>({ logDateStart: '', logDateEnd: '' });
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  const { rows, busy, load } = useStatQuery(pageId, 'yearMonth');
  return (
    <ReportPanel pageId={pageId} title="登入使用狀況統計">
      <ReportRow pageId={pageId} name="log-date-start" label="登入時間：" star>
        <input
          data-ui-id={`${pageId}-field-log-date-start`}
          name="logDateStart"
          type="date"
          required
          className="rounded border border-border px-2 py-1 text-sm"
          value={values['logDateStart'] ?? ''}
          onChange={(event) => {
            set('logDateStart', event.target.value);
          }}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name="log-date-end" label="~">
        <input
          data-ui-id={`${pageId}-field-log-date-end`}
          name="logDateEnd"
          type="date"
          required
          className="rounded border border-border px-2 py-1 text-sm"
          value={values['logDateEnd'] ?? ''}
          onChange={(event) => {
            set('logDateEnd', event.target.value);
          }}
        />
        {/* 橡皮擦（:242-245 resetDateTimePicker 鏡像）。 */}
        <Button
          uiId={`${pageId}-field-eraser-log-date-start`}
          variant="default"
          size="sm"
          type="button"
          onClick={() => {
            set('logDateStart', '');
            set('logDateEnd', '');
          }}
        >
          清除
        </Button>
      </ReportRow>
      <div data-ui-id={`${pageId}-actions`} className="col-span-2 flex gap-2">
        <StatActions
          pageId={pageId}
          busy={busy}
          hasPrint={false}
          onQuery={() => {
            // :66-74 請選擇登入時間（**兩個條件都檢 logDateEnd**（:65 兩支都是 #logDateEnd——
            // logDateStart 從未被檢＝copy-paste legacy-known-issue 照實）；logDateEnd 空即擋）。
            if ((values['logDateEnd'] ?? '') === '') {
              void dialogs.alert('請選擇登入時間');
              return;
            }
            load({ logDateStart: values['logDateStart'] ?? '', logDateEnd: values['logDateEnd'] ?? '' });
          }}
        />
      </div>
      <div className="col-span-2">
        {/* RPT-001（批次 33，issue #34）：pie×2（LoginStatic.jsp:130-155 drawPie/:156-181 drawPie2；
            圖在表格前＝共通事實 6）。資料＝rows 加總（:87-90 loginTime/loginAccountNums 總和）→
            各月份占比 rate.toFixed(2)（:95-98）；labels＝yearMonth（:93）；兩面同用 dataColor
            （:100 dataColor2.push 同一個 newColor；這裡非 quirk，兩面等長同色序）。 */}
        <div style={{ width: '75%' }}>
          <PieCanvas
            uiId={`${pageId}-canvas`}
            title="登入次數統計"
            slices={(() => {
              const total = rows.reduce((sum, row) => sum + Number(row['loginTime'] ?? 0), 0) || 1;
              return rows.map((row, i) => ({
                label: String(row['yearMonth'] ?? ''),
                value: Number(((Number(row['loginTime'] ?? 0) / total) * 100).toFixed(2)),
                color: chartColorAt(i),
              }));
            })()}
          />
          <PieCanvas
            uiId={`${pageId}-canvas2`}
            title="登入人次統計"
            slices={(() => {
              const total = rows.reduce((sum, row) => sum + Number(row['loginAccountNums'] ?? 0), 0) || 1;
              return rows.map((row, i) => ({
                label: String(row['yearMonth'] ?? ''),
                value: Number(((Number(row['loginAccountNums'] ?? 0) / total) * 100).toFixed(2)),
                color: chartColorAt(i),
              }));
            })()}
          />
        </div>
      </div>
      <div className="col-span-2">
        {/* 表（thead :250-252 項目/登入次數/登入人次）；pie 圖×2 已由批次 33 自繪（RPT-001）。 */}
        <Table
          uiId={`${pageId}-stat-table`}
          columns={[
            { key: 'yearMonth', header: '項目', align: 'center' },
            { key: 'loginTime', header: '登入次數', align: 'center' },
            { key: 'loginAccountNums', header: '登入人次', align: 'center' },
          ]}
          rows={rows.map((row) => ({ ...row }))}
          rowKey={(row) => String(row['yearMonth'] ?? '')}
        />
      </div>
    </ReportPanel>
  );
}

/** dialogs.alert 的獨立取用（StatActions 內無法直接用 hooks——由 body 層取好傳入較乾淨；
 *  這裡用一個小 helper 包裝以維持宣告簡潔；實作上仍是 useDialogs 的結果）。 */

// ---------------------------------------------------------------------------
// 2/3. 滿意度統計（classFormStatic 6/7＋planFormStatic 4/5）——六欄統計表
// ---------------------------------------------------------------------------

interface StatBodyConfig {
  readonly title: string;
  readonly refType: string;
  readonly hasClassId: boolean;
  readonly statKey: string; // 種子鍵（fieldTitlem）
  readonly seed: readonly Row[];
}

/** 六欄統計表的渲染（項目/平均/最低/最高/中位數/眾數；classFormStatic thead 3 欄照實錯置）。 */
function StatTable(props: { pageId: string; rows: readonly Row[]; brokenHeader: boolean }): ReactElement {
  const columns: readonly TableColumn[] = props.brokenHeader
    ? [
        { key: 'fieldTitlem', header: '月份', align: 'left' },
        { key: 'averageValue', header: '登入次數', align: 'center' },
        { key: 'minValue', header: '登入人次', align: 'center' },
        { key: 'maxValue', header: '', align: 'center' },
        { key: 'medianValue', header: '', align: 'center' },
        { key: 'majorityValue', header: '', align: 'center' },
      ]
    : [
        { key: 'fieldTitlem', header: '項目', align: 'left' },
        { key: 'averageValue', header: '平均', align: 'center' },
        { key: 'minValue', header: '最低', align: 'center' },
        { key: 'maxValue', header: '最高', align: 'center' },
        { key: 'medianValue', header: '中位數', align: 'center' },
        { key: 'majorityValue', header: '眾數', align: 'center' },
      ];
  return (
    <Table
      uiId={`${props.pageId}-stat-table`}
      columns={columns}
      rows={props.rows.map((row) => ({ ...row }))}
      rowKey={(row) => String(row['fieldTitlem'] ?? '')}
    />
  );
}

/** classFormStatic/planFormStatic 的共用 body（差異：標題/refType/hasClassId/種子/表頭）。 */
function SatisfactionLikeBody(props: {
  pageId: string;
  config: StatBodyConfig;
}): ReactElement {
  const { pageId, config } = props;
  const satisfactionDialogs = useDialogs();
  const [values, setValues] = useState<Record<string, string>>({
    refType: config.refType,
    teacherId: '',
    classId: '',
    submitDateS: '',
    submitDateE: '',
  });
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
  // （規格 §7.1；override 命中含空陣列即移除 placeholder 空選項；凍結 teacherId/classId 首項
  // 本身即請選擇('')＝override 帶回後 placeholder 同步去除）。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);
  const { rows, busy, load } = useStatQuery(pageId, config.statKey);
  return (
    <ReportPanel pageId={pageId} title={config.title}>
      {/* refType hidden（契約 hidden；value＝契約捕捉值 6/7/4/5）。 */}
      <input type="hidden" name="refType" value={config.refType} readOnly />
      <ReportRow pageId={pageId} name="teacherId" label="教師：">
        <Select
          uiId={`${pageId}-field-teacher-id`}
          name="teacherId"
          value={values['teacherId'] ?? ''}
          onChange={(next) => {
            set('teacherId', next);
          }}
          options={overrideOptions('teacherId') ?? COURSE_CLAZZ_TEACHER_OPTIONS}
          {...(overrideOptions('teacherId') ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      {config.hasClassId ? (
        <ReportRow pageId={pageId} name="classId" label="課程：">
          <Select
            uiId={`${pageId}-field-class-id`}
            name="classId"
            value={values['classId'] ?? ''}
            onChange={(next) => {
              set('classId', next);
            }}
            options={overrideOptions('classId') ?? REPORT_CLASS_OPTIONS}
            {...(overrideOptions('classId') ? {} : { placeholder: '請選擇' })}
          />
        </ReportRow>
      ) : null}
      <StatDateRange pageId={pageId} ctx={{ v: values, set }} startName="submitDateS" endName="submitDateE" required eraser />
      <div data-ui-id={`${pageId}-actions`} className="col-span-2 flex gap-2">
        <StatActions
          pageId={pageId}
          busy={busy}
          hasPrint
          onQuery={() => {
            // :81-98（classFormStatic）／:65-83（planFormStatic）：classId 空且起訖空 →
            // 請選擇表單時間（學年度/醫院檢核整段被註解＝legacy-known-issue 照實）。
            if (
              (values['classId'] ?? '') === '' &&
              ((values['submitDateS'] ?? '') === '' || (values['submitDateE'] ?? '') === '')
            ) {
              void satisfactionDialogs.alert('請選擇表單時間');
              return;
            }
            load({
              refType: config.refType,
              teacherId: values['teacherId'] ?? '',
              classId: values['classId'] ?? '',
              submitDateS: values['submitDateS'] ?? '',
              submitDateE: values['submitDateE'] ?? '',
            });
          }}
        />
      </div>
      {/* RPT-001（批次 33，issue #34）：line＋bar（classFormStatic.jsp drawLine :169-229／drawBar :231-260；
          planFormStatic.jsp 同構）。圖在表格前＝共通事實 6。line 5 datasets：平均 red/最低 purple/
          最高 skyblue（**色票不存在**＝undefined → Chart.js 預設灰，quirk 照實）/中位數 blue/眾數 green，
          fill:false；bar 1 dataset 平均（green alpha 0.5，:246）；labels＝fieldTitlem；title＝pageTitle＝config.title。
          資料＝rows 六統計欄（server 算好，:101）；scales 項次/分數（:213-229）。 */}
      <div className="col-span-2" style={{ width: '75%' }}>
        <LineCanvas
          uiId={`${pageId}-canvas`}
          title={config.title}
          labels={rows.map((row) => String(row['fieldTitlem'] ?? ''))}
          xAxisLabel="項次"
          yAxisLabel="分數"
          datasets={[
            { label: '平均', data: rows.map((row) => Number(row['averageValue'] ?? 0)), color: 'rgb(255, 99, 132)' },
            { label: '最低', data: rows.map((row) => Number(row['minValue'] ?? 0)), color: 'rgb(153, 102, 255)' },
            { label: '最高', data: rows.map((row) => Number(row['maxValue'] ?? 0)), color: 'rgba(0, 0, 0, 0.1)' }, // skyblue quirk
            { label: '中位數', data: rows.map((row) => Number(row['medianValue'] ?? 0)), color: 'rgb(54, 162, 235)' },
            { label: '眾數', data: rows.map((row) => Number(row['majorityValue'] ?? 0)), color: 'rgb(75, 192, 192)' },
          ]}
        />
        <BarCanvas
          uiId={`${pageId}-canvas2`}
          title={config.title}
          labels={rows.map((row) => String(row['fieldTitlem'] ?? ''))}
          xAxisLabel="項次"
          yAxisLabel="分數"
          datasets={[{ label: '平均', data: rows.map((row) => Number(row['averageValue'] ?? 0)), color: 'rgb(75, 192, 192)' }]}
        />
      </div>
      <div className="col-span-2">
        {/* classFormStatic 的表頭 3 欄 vs 資料 6 欄＝copy-paste legacy-known-issue 照實；
            planFormStatic 表頭 6 欄相符（:378）。 */}
        <StatTable pageId={pageId} rows={rows} brokenHeader={config.hasClassId} />
      </div>
    </ReportPanel>
  );
}

export function ClassFormStaticBody({ pageId }: { pageId: string }): ReactElement {
  return (
    <SatisfactionLikeBody
      pageId={pageId}
      config={{ title: '課程滿意度調查統計', refType: '6', hasClassId: true, statKey: 'fieldTitlem', seed: [] }}
    />
  );
}

export function ClassFormStatic7Body({ pageId }: { pageId: string }): ReactElement {
  return (
    <SatisfactionLikeBody
      pageId={pageId}
      config={{ title: '基本課程滿意度調查統計', refType: '7', hasClassId: true, statKey: 'fieldTitlem', seed: [] }}
    />
  );
}

export function PlanFormStaticBody({ pageId }: { pageId: string }): ReactElement {
  return (
    <SatisfactionLikeBody
      pageId={pageId}
      config={{ title: '主治醫師教學滿意度統計', refType: '4', hasClassId: false, statKey: 'fieldTitlem', seed: [] }}
    />
  );
}

export function PlanFormStatic5Body({ pageId }: { pageId: string }): ReactElement {
  return (
    <SatisfactionLikeBody
      pageId={pageId}
      config={{ title: '住院醫師教學滿意度統計', refType: '5', hasClassId: false, statKey: 'fieldTitlem', seed: [] }}
    />
  );
}

// ---------------------------------------------------------------------------
// 4. 教學門診稽核表統計群（planFormStatic2 8/9/10）——項目/通過率
// ---------------------------------------------------------------------------

function PassRateLikeBody(props: { pageId: string; title: string; refType: string }): ReactElement {
  const { pageId } = props;
  const [values, setValues] = useState<Record<string, string>>({
    refType: props.refType,
    phaseDepartmentId: '',
    submitDateS: '',
    submitDateE: '',
  });
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數（規格 §7.1）。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);
  const dialogs = useDialogs();
  const { rows, busy, load } = useStatQuery(pageId, 'fieldTitlem', () => {
    // :106 無資料!（legacy 對空 list 的處理）。
    void dialogs.alert('無資料!');
  });
  return (
    <ReportPanel pageId={pageId} title={props.title}>
      <input type="hidden" name="refType" value={props.refType} readOnly />
      <ReportRow pageId={pageId} name="phaseDepartmentId" label="訓練階段科部：" star>
        <Select
          uiId={`${pageId}-field-phase-department-id`}
          name="phaseDepartmentId"
          value={values['phaseDepartmentId'] ?? ''}
          onChange={(next) => {
            set('phaseDepartmentId', next);
          }}
          options={overrideOptions('phaseDepartmentId') ?? [{ value: '', label: '全部' }, ...ACCOUNT_DEPARTMENT_OPTIONS]}
        />
      </ReportRow>
      <StatDateRange pageId={pageId} ctx={{ v: values, set }} startName="submitDateS" endName="submitDateE" required eraser />
      <div data-ui-id={`${pageId}-actions`} className="col-span-2 flex gap-2">
        <StatActions
          pageId={pageId}
          busy={busy}
          hasPrint
          onQuery={() => {
            // :80-88 請選擇表單時間。
            if ((values['submitDateS'] ?? '') === '' || (values['submitDateE'] ?? '') === '') {
              void dialogs.alert('請選擇表單時間');
              return;
            }
            // :92-95 參數（submitDateS/E/phaseDepartmentId/refType）。
            load({
              refType: props.refType,
              phaseDepartmentId: values['phaseDepartmentId'] ?? '',
              submitDateS: values['submitDateS'] ?? '',
              submitDateE: values['submitDateE'] ?? '',
            });
            // :106 無資料!（list 空物件）——load 完成後由下方 effect 檢查。
          }}
        />
      </div>
      {/* RPT-001（批次 33，issue #34）：bar＋pie（planFormStatic2.jsp drawBar :202-220／drawPie :245-260）。
          圖在表格前＝共通事實 6。bar 1 dataset 通過率（green alpha 0.5，:203-206；JSP push 原值 0~1 照實）。
          pie＝scoreGroup B 列的 optionNameList 計數占比（:162-172 workData2/workTotal）；
          **色 quirk 照實**：dataColor 取迴圈殘值 colorNames[cx]（cx 已超界）＝undefined×N →
          Chart.js 預設灰，pie 全灰。labels＝fieldTitlem（A 群）；pieTitle＝B 群 fieldTitlem。 */}
      <div className="col-span-2" style={{ width: '75%' }}>
        <BarCanvas
          uiId={`${pageId}-canvas`}
          title={props.title}
          labels={rows.filter((row) => row['scoreGroup'] !== 'B').map((row) => String(row['fieldTitlem'] ?? ''))}
          xAxisLabel="項次"
          yAxisLabel="分數"
          datasets={[
            {
              label: '通過率',
              data: rows.filter((row) => row['scoreGroup'] !== 'B').map((row) => Number(row['passRate'] ?? 0)),
              color: 'rgb(75, 192, 192)',
            },
          ]}
        />
        {(() => {
          // scoreGroup B：optionNameList 計數→pie（JSP :162-172）。
          const bRows = rows.filter((row) => row['scoreGroup'] === 'B');
          if (bRows.length === 0) return null;
          const counts = new Map<string, number>();
          let total = 0;
          for (const row of bRows) {
            const opts = Array.isArray(row['optionNameList']) ? (row['optionNameList'] as ReadonlyArray<unknown>) : [];
            for (const op of opts) {
              const key = String(op);
              counts.set(key, (counts.get(key) ?? 0) + 1);
              total += 1;
            }
          }
          const pieTitle = String(bRows[0]?.['fieldTitlem'] ?? '');
          return (
            <PieCanvas
              uiId={`${pageId}-canvas2`}
              title={pieTitle}
              slices={[...counts.entries()].map(([, count]) => ({
                label: pieTitle,
                value: Number(((count / (total || 1)) * 100).toFixed(2)),
                color: 'rgba(0, 0, 0, 0.1)', // 殘值 cx quirk：全 undefined＝Chart.js 預設灰
              }))}
            />
          );
        })()}
      </div>
      <div className="col-span-2">
        {/* 表（thead :397 項目/通過率；passRate ×100 toFixed(2) :122/:147-149）——僅 scoreGroup A 群
            （JSP :156-165：A 群才 append 表格列，B 群只計入 pie）；無 scoreGroup 欄的舊列視同 A。 */}
        <Table
          uiId={`${pageId}-stat-table`}
          columns={[
            { key: 'fieldTitlem', header: '項目', align: 'left' },
            {
              key: 'passRate',
              header: '通過率',
              align: 'center',
            },
          ]}
          rows={rows
            .filter((row) => row['scoreGroup'] !== 'B')
            .map((row) => ({
            ...row,
            passRate:
              row['passRate'] === undefined
                ? ''
                : `${(Number(row['passRate']) * 100).toFixed(2)}`,
          }))}
          rowKey={(row) => String(row['fieldTitlem'] ?? '')}
        />
      </div>
    </ReportPanel>
  );
}

export function PlanFormStatic2Body({ pageId }: { pageId: string }): ReactElement {
  return <PassRateLikeBody pageId={pageId} title="教學門診稽核表統計" refType="8" />;
}

export function PlanFormStatic9Body({ pageId }: { pageId: string }): ReactElement {
  return <PassRateLikeBody pageId={pageId} title="教學住診暨床邊教學統計" refType="9" />;
}

export function PlanFormStatic10Body({ pageId }: { pageId: string }): ReactElement {
  return <PassRateLikeBody pageId={pageId} title="晨會訓練官稽核檢查表統計" refType="10" />;
}

// ---------------------------------------------------------------------------
// 5. 核心技能統計(依技能)/(依學員)（coreSkillReportByForm/byStudent）——ready 即查詢
// ---------------------------------------------------------------------------

/** by-form 完成率渲染（coreSkillReportByForm.jsp :16-26：兩者>0 才計，否則 0.00%）。 */
function finishRateOf(row: Row): string {
  const need = Number(row['needFillNum'] ?? 0);
  const real = Number(row['realFillNum'] ?? 0);
  if (need > 0 && real > 0) {
    return `${((real / need) * 100).toFixed(2)}%`;
  }
  return '0.00%';
}

function CoreSkillReportLikeBody(props: { pageId: string; title: string; queryType: '1' | '0'; byStudent: boolean }): ReactElement {
  const { pageId } = props;
  const [values, setValues] = useState<Record<string, string>>({
    queryType: props.queryType,
    annualId: '114',
    organizationId: '',
    jobTypeId: '',
  });
  const set = (key: string, next: string) => {
    setValues((current) => ({ ...current, [key]: next }));
  };
  // 批次 52 修訂（b52-calibrate3，F-2）：OPTION_SET_OVERRIDES 命中＝凍結選項集取代寫死常數
  // （規格 §7.1；by-form/by-student 三鍵凍結真真空＝[]，0 options 連 placeholder 都不畫）。
  const overrideOptions = (name: string) => selectOptionsOverride(pageId, name);
  const { rows, busy, load } = useStatQuery(pageId, props.byStudent ? 'studentName' : 'formName');
  // ready 即自動查詢（by-form :8-11／by-student :10-13）。
  // biome-ignore lint/correctness/useExhaustiveDependencies: pageId 掛載內不變，首載一次。
  useEffect(() => {
    load({ queryType: props.queryType, annualId: '114', organizationId: '', jobTypeId: '' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const byStudentRows: readonly TableRow[] = rows.map((row) => {
    const desc = Array.isArray(row['formDesc']) ? (row['formDesc'] as ReadonlyArray<Row>) : [];
    const flat: Row = { studentName: row['studentName'] ?? '' };
    for (const [index, entry] of desc.entries()) {
      let value: string | number = String(entry['realFillNum'] ?? '');
      // by-student :92-94 特例：formName 以 '4-1基本及高階急救_' 開頭且 realFillNum==1 → 0.5。
      if (
        String(entry['formName'] ?? '').indexOf('4-1基本及高階急救_') === 0 &&
        Number(entry['realFillNum']) === 1
      ) {
        value = 0.5;
      }
      flat[`formName_${String(index)}`] = value;
    }
    return flat;
  });
  const firstStudent = rows[0];
  const studentColumns: readonly TableColumn[] = [
    { key: 'studentName', header: '學員姓名', align: 'center' },
    ...(firstStudent === undefined
      ? []
      : ((firstStudent['formDesc'] ?? []) as ReadonlyArray<Row>).map((entry, index) => ({
          // 欄名＝formName＋needFillNum（by-student :87 title 鏡像，以文字呈現）。
          key: `formName_${String(index)}`,
          header: `${String(entry['formName'] ?? '')} [${String(entry['needFillNum'] ?? '')}]`,
          align: 'center' as const,
        }))),
  ];
  return (
    <ReportPanel pageId={pageId} title={props.title}>
      <input type="hidden" name="queryType" value={props.queryType} readOnly />
      <ReportRow pageId={pageId} name="annualId" label="學年度：">
        <Select
          uiId={`${pageId}-field-annual-id`}
          name="annualId"
          value={values['annualId'] ?? ''}
          onChange={(next) => {
            set('annualId', next);
          }}
          options={overrideOptions('annualId') ?? COURSE_CLAZZ_ANNUAL_OPTIONS}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name="organizationId" label="醫院：">
        <Select
          uiId={`${pageId}-field-organization-id`}
          name="organizationId"
          value={values['organizationId'] ?? ''}
          onChange={(next) => {
            set('organizationId', next);
          }}
          options={overrideOptions('organizationId') ?? ACCOUNT_ORGANIZATION_OPTIONS}
          {...(overrideOptions('organizationId') ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <ReportRow pageId={pageId} name="jobTypeId" label="訓練類別：">
        <Select
          uiId={`${pageId}-field-job-type-id`}
          name="jobTypeId"
          value={values['jobTypeId'] ?? ''}
          onChange={(next) => {
            set('jobTypeId', next);
          }}
          options={overrideOptions('jobTypeId') ?? ACCOUNT_JOB_TYPE_OPTIONS}
          {...(overrideOptions('jobTypeId') ? {} : { placeholder: '請選擇' })}
        />
      </ReportRow>
      <div data-ui-id={`${pageId}-actions`} className="col-span-2 flex gap-2">
        <StatActions
          pageId={pageId}
          busy={busy}
          hasPrint={false}
          onQuery={() => {
            // doQuery 無驗證（valid 被註解 :28-31＝legacy-known-issue 照實）。
            load({ queryType: props.queryType, ...values });
          }}
        />
      </div>
      <div className="col-span-2">
        {props.byStudent ? (
          <Table
            uiId={`${pageId}-stat-table`}
            columns={studentColumns}
            rows={byStudentRows}
            rowKey={(row) => String(row['studentName'] ?? '')}
          />
        ) : (
          <Table
            uiId={`${pageId}-stat-table`}
            columns={[
              { key: 'formName', header: '項目', align: 'left' },
              { key: 'finishRate', header: '完成率', align: 'center' },
            ]}
            rows={rows.map((row) => ({ ...row, finishRate: finishRateOf(row) }))}
            rowKey={(row) => String(row['formName'] ?? '')}
          />
        )}
      </div>
    </ReportPanel>
  );
}

export function CoreSkillReportByFormStatBody({ pageId }: { pageId: string }): ReactElement {
  return <CoreSkillReportLikeBody pageId={pageId} title="核心技能統計(依技能)" queryType="1" byStudent={false} />;
}

export function CoreSkillReportByStudentStatBody({ pageId }: { pageId: string }): ReactElement {
  return <CoreSkillReportLikeBody pageId={pageId} title="核心技能統計(依學員)" queryType="0" byStudent />;
}

